import { useState } from "react";
import { AdvancedMarker, InfoWindow } from "@vis.gl/react-google-maps";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { VehicleCard } from "./VehicleCard";
import { SaveDealershipButton } from "./SaveDealershipButton";
import { useThemeStore } from "../../stores/themeStore";

export const CustomMarker = ({ dealership }) =>  {
    const [showInfo, setShowInfo] = useState(false);
    const theme = useThemeStore((state) => state.theme);
    const isDark = theme === 'dark';
    const position = {
        lat: Number(dealership.latitude),
        lng: Number(dealership.longitude),
    };

    const listings = dealership.listings

    // We don't get a dealership homepage in the payload, so derive it from the
    // origin of any listing's dealer-site URL (e.g. northhollywoodtoyota.com).
    const dealerSite = (() => {
        const url = listings.find((l) => l.listing_url)?.listing_url
        if (!url) return null
        try { return new URL(url).origin } catch (_e) { return url }
    })()

    // Rendered in the InfoWindow's header row (same line as the X close button).
    // Inline-styled because the header is portaled outside the #ListingsPage
    // scope, so the page's scoped CSS can't reach it.
    const header = (
        <div style={{display: 'flex', alignItems: 'center', gap: '8px', fontFamily: "'DM Sans', sans-serif"}}>
            <span style={{fontSize: '14px', fontWeight: 600, color: isDark ? '#f0f2f5' : '#1a1d23'}}>{dealership.name}</span>
            {
                dealerSite &&
                <a
                    href={dealerSite}
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Open dealership site"
                    style={{display: 'inline-flex', alignItems: 'center', color: isDark ? '#3b82f6' : '#2563eb', cursor: 'pointer'}}
                >
                    <OpenInNewIcon style={{fontSize: '16px'}}/>
                </a>
            }
            <span style={{fontSize: '12px', fontWeight: 500, color: isDark ? '#8b95a8' : '#8a8f9e'}}>
                {listings.length} {listings.length === 1 ? 'listing' : 'listings'}
            </span>
            <SaveDealershipButton dealership={dealership} size={18}/>
        </div>
    )

    return (
        <>
            <AdvancedMarker position={position} onClick={() => setShowInfo(true)}>
                {
                    !showInfo &&
                    <div style={{
                        fontFamily: "'DM Sans', sans-serif",
                        background: "#ffffff",
                        border: "1px solid #e2e4e9",
                        borderRadius: "20px",
                        padding: "5px 12px",
                        fontSize: "13px",
                        fontWeight: "600",
                        color: "#1a1d23",
                        cursor: "pointer",
                        whiteSpace: "nowrap",
                        boxShadow: "0 1px 3px rgba(0,0,0,0.06), 0 4px 12px rgba(0,0,0,0.04)",
                        transition: "box-shadow .2s, transform .2s",
                    }}
                         onMouseEnter={e => {
                             e.currentTarget.style.boxShadow = "0 4px 20px rgba(0,0,0,0.1)";
                             e.currentTarget.style.transform = "translateY(-2px)";
                         }}
                         onMouseLeave={e => {
                             e.currentTarget.style.boxShadow = "0 1px 3px rgba(0,0,0,0.06), 0 4px 12px rgba(0,0,0,0.04)";
                             e.currentTarget.style.transform = "translateY(0)";
                         }}
                    >
                        🏢 {dealership.name}
                    </div>
                }
            </AdvancedMarker>

            {showInfo && (
                <InfoWindow
                    position={position}
                    onCloseClick={() => setShowInfo(false)}
                    headerContent={header}
                >
                    {/* id="ListingsPage" re-scopes the page's card styles here —
                        the InfoWindow is portaled outside the page root, so the
                        scoped .vehicle-card/.vehicle-grid rules need this anchor. */}
                    <div id="ListingsPage" data-theme={theme} className="map-listings-popup">
                        <div className="vehicle-grid map-listings-grid">
                            {listings.map((listing) => (
                                <VehicleCard key={listing.vin || listing.id} vehicle={listing}/>
                            ))}
                        </div>
                    </div>
                </InfoWindow>
            )}
        </>
    );
}